import React from 'react';
import { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles';
import logo from './st_mary_logo.jpg';
import './App.css';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import SwipeableViews from 'react-swipeable-views';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Sidebar from './Sidebar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import clsx from 'clsx';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#90caf9'
    },
    secondary: {
      main: '#f48fb1'
    },
    error: {
      main: '#000000'
    }
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function TabPanelNoPadding(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          {children}
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    textAlign: 'center',
    width: '100%',
  },
  app_logo: {
    width: 30,
    float: 'left'
  }
}));

const LinkList = ({ title, links, setOpen }) => {
  const classes = useStyles();
  const [surpriseClickNum, setSurpriseClickNum] = useState(0);

  const birthdaySurpise = () => {
    if (title == "7-8th Grade") {
      setSurpriseClickNum(surpriseClickNum + 1);
    }
    console.log(setSurpriseClickNum)
    if (surpriseClickNum >= 25) {
      setOpen(true);
      setSurpriseClickNum(0);
    }
  }

  return (
    <Grid item xs={12} md={3}>
      <Paper style={{ height: '100%' }} elevation={5} >
        <Typography variant="h5" color="primary" className={classes.title} onClick={birthdaySurpise}>
          {title}
        </Typography>
        <div>
          <List>
            {links.map((link, i) =>
              <ListItem>
                <Button style={{ width: '100%', textAlign: 'center', margin: 'auto' }} variant="outlined" color="primary" href={link.link}>
                  {link.name}
                </Button>
              </ListItem>
            )}
          </List>
        </div>
      </Paper>
    </Grid>
  );
};

function App() {
  const classes = useStyles();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [passVal, setPassVal] = useState('');
  const [tabIndexValue, setTabIndexValue] = useState(0);

  const preKAndKG = [
    {
      "name": "Sunday School (@1:00)",
      "link": "https://depaul.zoom.us/j/94517163030?pwd=bEZVMnRnM3VteFhXbGdLVW9iWTFsQT09"
    },
    {
      "name": "Bible Study (Monday @6:30)",
      "link": "https://us02web.zoom.us/j/87332663725?pwd=VHpuWTdvQWJ2dEcrR3hOcGszWU83dz09"
    },
    {
      "name": "Reading Tutoring for Kindergarten Only (Tuesday @6:00)",
      "link": "https://depaul.zoom.us/j/94517163030?pwd=bEZVMnRnM3VteFhXbGdLVW9iWTFsQT09"
    },
    {
      "name": "Hymns (Wednesday @6:30)",
      "link": "https://depaul.zoom.us/j/94517163030?pwd=bEZVMnRnM3VteFhXbGdLVW9iWTFsQT09"
    }
  ];

  const firstAndSecond = [
    {
      "name": "Prayer Meeting (Monday @7:00)",
      "link": "https://luc.zoom.us/j/95144017290"
    },
    {
      "name": "Book Club (Thursday @7:00)",
      "link": "https://us04web.zoom.us/j/71184843557?pwd=a0MrOVBYeEhvYmVTdXNhVzdMMnRjZz09"
    },
    {
      "name": "Daily Blessing (Wednesday @7:00)",
      "link": "https://us02web.zoom.us/j/84270109689?pwd=VXB3SU5YUEdJK0d6SURyWU1DaFRHUT09"
    }
  ];
  const thirdAndFourth = [
    {
      "name": "Prayer Meeting (Monday @7:00)",
      "link": "https://luc.zoom.us/j/95144017290"
    },
    {
      "name": "Book Club (Thursday @7:40)",
      "link": "https://us04web.zoom.us/j/71184843557?pwd=a0MrOVBYeEhvYmVTdXNhVzdMMnRjZz09"
    },
    {
      "name": "Daily Blessing (Wednesday @7:00)",
      "link": "https://luc.zoom.us/j/95144017290"
    }
  ];

  const fifthAndSixth = [
    {
      "name": "Sunday School (@1:00)",
      "link": "https://us02web.zoom.us/j/81927806224"
    },
    {
      "name": "Math & Reading at 6th Grade Level (Monday @5:00)",
      "link": "https://luc.zoom.us/j/97090407284"
    },
    {
      "name": "Social Hour (Tuesday @7:00)",
      "link": "https://luc.zoom.us/j/434722416"
    },
    {
      "name": "TOP (Wednesday @6:15)",
      "link": "https://uic.zoom.us/j/93315892384?pwd=LzcyTE5uR2w2M2JsNkwzeG82M2Nadz09"
    },
    {
      "name": "Book Club (Thursday @7:30)",
      "link": "https://luc.zoom.us/j/97090407284"
    },
    {
      "name": "Bible Study (Friday @6:00)",
      "link": "https://luc.zoom.us/j/625328006"
    },
  ]

  const seventhAndEighth = [
    {
      "name": "Sunday School (@12:30)",
      "link": "https://us02web.zoom.us/j/83595508063?pwd=RVZScHpiMU03VUNnYkZSUitvVTgzQT09"
    },
    {
      "name": "PreAlgebra/Algebra 1 & English Tutoring (Tuesday @5:00)",
      "link": "https://glenbrook225.zoom.us/j/88339786511?pwd=b3FsemJISXh5VlU2R3NZZUxDTXRMQT09"
    },
    {
      "name": "TOP (Wednesday @6:15)",
      "link": "https://uic.zoom.us/j/93315892384?pwd=LzcyTE5uR2w2M2JsNkwzeG82M2Nadz09"
    },
    {
      "name": "Book Club (Thursday @7:30)",
      "link": "https://luc.zoom.us/j/97090407284"
    },
    {
      "name": "Bible Study & Social Hour (Friday @6:00)",
      "link": "https://us02web.zoom.us/j/88465678929?pwd=UUlJNVFqcmJaa3hpdVczYW9XQVE0Zz09"
    },
  ]

  const highSchool = [
    {
      "name": "9th and 10th Sunday School (@1:00)",
      "link": "https://us02web.zoom.us/j/4216233639?pwd=ZHFQQ25UU0h2ZWtOb2dJUitqbWlOUT09"
    },
    {
      "name": "11th and 12th Sunday School (@1:00)",
      "link": "https://uic.zoom.us/j/94784775147?pwd=Mjk4U2E4UGNYNXhvclh5a3pkNE9Jdz09"
    },
    {
      "name": "Servants Prep (Sunday @2:30)",
      "link": "https://uic.zoom.us/j/94784775147?pwd=Mjk4U2E4UGNYNXhvclh5a3pkNE9Jdz09"
    },
    {
      "name": "Book Club (Tuesday @7:30)",
      "link": "https://us02web.zoom.us/j/4216233639?pwd=ZHFQQ25UU0h2ZWtOb2dJUitqbWlOUT09"
    },
    {
      "name": "TOP (Wednesday @7:00)",
      "link": "https://uic.zoom.us/j/93315892384?pwd=LzcyTE5uR2w2M2JsNkwzeG82M2Nadz09"
    },
    {
      "name": "SAT/ACT Review (Thursday @6:00)",
      "link": "https://luc.zoom.us/j/83997259415"
    },
    {
      "name": "Bible Study + Social Hour (Friday @7:00)",
      "link": "https://us02web.zoom.us/j/4216233639?pwd=ZHFQQ25UU0h2ZWtOb2dJUitqbWlOUT09"
    }
  ];
  const fellowship = [
    {
      "name": "Bible Study (Catena) (Sunday @7:30)",
      "link": "https://catenabible.com/live/Gw4_gKpeJ"
    },
    {
      "name": "LIT Book Club (Wednesday @8:00)",
      "link": "https://depaul.zoom.us/j/97637381557"
    },
    {
      "name": "DIG (Thursday @8:00)",
      "link": "https://depaul.zoom.us/j/97547925925"
    },
    {
      "name": "Friday Fellowship (@7:30)",
      "link": "https://mazarsusa.zoom.us/j/99546378619"
    },
    {
      "name": "English Prayer Meeting (Daily @9:30)",
      "link": "https://depaul.zoom.us/j/97547925925"
    }
  ];
  const parentFamily = [
    {
      "name": "Sunday Arabic Bible Study (Sunday @1:00)",
      "link": "https://us02web.zoom.us/j/3245792590"
    },
    {
      "name": "Pilgrim George Meeting (2nd & 4th Sunday @6:00)",
      "link": "https://us02web.zoom.us/j/88523969729?pwd=T08zVWs3OUFuNzFHSzVmakVjMmY5Zz09"
    },
    {
      "name": "Parents Book Club (Monday @7:30)",
      "link": "https://us02web.zoom.us/j/84270109689?pwd=VXB3SU5YUEdJK0d6SURyWU1DaFRHUT09"
    },
    {
      "name": "Women's Arabic Bible Study (Tuesday @8:00)",
      "link": "https://luc.zoom.us/j/87108794254"
    },
    {
      "name": "Friday Arabic Family Meeting (Friday @7:00)",
      "link": "https://stmarychicago.us3.list-manage.com/track/click?u=e5f534d5f9a28a33cacb622cb&id=2ce5554198&e=5aa1b175a9"
    },
    {
      "name": "Family Altar Prayer Meeting, Mixed (Daily @9:30)",
      "link": "https://zoom.us/j/300135889"
    },
  ];

  const hymns = [
    {
      "name": "St George (Monday @6:00)",
      "link": "https://us02web.zoom.us/j/84377529300?pwd=UmhyZ21SbTdlRnBta2F2d01xTHZzQT09"
    },
    {
      "name": "David the Prophet (Monday @7:30)",
      "link": "https://uic.zoom.us/j/93315892384?pwd=LzcyTE5uR2w2M2JsNkwzeG82M2Nadz09"
    },
    {
      "name": "3rd & 4th (Tuesday @7:00)",
      "link": "https://us04web.zoom.us/j/73656403330?pwd=ZWkrRlc3eUdiT1dIaCtkdUJJV1U0dz09"
    },
    {
      "name": "St Joseph (Adults) (Wednesday @7:00)",
      "link": "https://us04web.zoom.us/j/73656403330?pwd=ZWkrRlc3eUdiT1dIaCtkdUJJV1U0dz09"
    },
    {
      "name": "Pre-K (Wednesday @6:30)",
      "link": "https://depaul.zoom.us/j/94517163030?pwd=bEZVMnRnM3VteFhXbGdLVW9iWTFsQT09"
    },
    {
      "name": "1st & 2nd (Wednesday @6:30)",
      "link": "https://us04web.zoom.us/j/75539762433?pwd=cWMzTXJ4ajBZMnR4NVdWcVEwMWdWZz09"
    },
    {
      "name": "St Mina (Saturday @5:30)",
      "link": "https://depaul.zoom.us/j/97547925925"
    },
    {
      "name": "St Moses (Saturday @5:30)",
      "link": "https://depaul.zoom.us/j/97547925925"
    },
  ];

  const servants = [
    {
      "name": "General Servants Meeting (1st Sunday @6 pm)",
      "link": "https://depaul.zoom.us/j/97547925925"
    },
    {
      "name": "All Servants Bible Study (3rd Sunday @6 pm)",
      "link": "https://depaul.zoom.us/j/97547925925"
    }
  ];

  const handleChangeTab = (event, newValue) => {
    setTabIndexValue(newValue);
  };

  const handleChangeTabIndex = (index) => {
    setTabIndexValue(index);
  };

  return (
    <ThemeProvider theme={darkTheme} >
      <Dialog onClose={() => setOpen(false)} aria-labelledby="happy-birthday" open={open} style={{ padding: 10 }}>
        <DialogTitle id="happy-birthday-title">Authorized Only</DialogTitle>
        {passVal == "batatis" ? <p style={{ margin: 10 }}>Ayyyyy happy birthday!</p> :
          <React.Fragment>
            <TextField id="standard-basic" label="Password" onChange={(val) => setPassVal(val.target.value)} />
            <Button>Login</Button>
          </React.Fragment>
        }
      </Dialog>
      {/* <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}></Sidebar> */}
      <Paper style={{ padding: 10, backgroundColor: darkTheme.palette.background.default }} elevation={0}>
        <AppBar position="fixed">
          <Toolbar>
            {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={(event)=>{setSidebarOpen(!sidebarOpen)}}>
            <MenuIcon />
          </IconButton> */}
            <Typography variant="h6" className={classes.title}>
              {/* <img src={logo} className={classes.app_logo}  alt="stmary_chicago" /> */}
              St Mary Coptic Orthodox Church
              {/* <br></br>Virtual Links */}
            </Typography>
          </Toolbar>
          <Tabs
            value={tabIndexValue}
            onChange={handleChangeTab}
            indicatorColor="secondary"

            variant="fullWidth"
          >
            <Tab label="Sunday School & Fellowship Links" />
            <Tab label="Make your Voice Heard" />
          </Tabs>
        </AppBar>

        <Toolbar />
        <Toolbar />
        <SwipeableViews
          axis={'x'}
          index={tabIndexValue}
          onChangeIndex={handleChangeTabIndex}
        >
          <TabPanel value={tabIndexValue} index={0}>
            <Grid container spacing={2} >
              <LinkList title="PreK and KG" links={preKAndKG} setOpen={setOpen} />
              <LinkList title="1-2nd Grade" links={firstAndSecond} setOpen={setOpen} />
              <LinkList title="3-4th Grade" links={thirdAndFourth} setOpen={setOpen} />
              {/* <LinkList title="5-8th Grade" links={middleSchool} setOpen={setOpen} /> */}
              <LinkList title="5-6th Grade" links={fifthAndSixth} setOpen={setOpen} />
              <LinkList title="7-8th Grade" links={seventhAndEighth} setOpen={setOpen} />
              <LinkList title="9-12th Grade" links={highSchool} setOpen={setOpen} />
              <LinkList title="Fellowship" links={fellowship} setOpen={setOpen} />
              <LinkList title="Parent / Family Services" links={parentFamily} setOpen={setOpen} />
              <LinkList title="Hymns Classes" links={hymns} setOpen={setOpen} />
              <LinkList title="Servants" links={servants} setOpen={setOpen} />
            </Grid>
          </TabPanel>
          <TabPanelNoPadding value={tabIndexValue} index={1}>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSciLzSkfK4RpYxqRXj-RTFgv7urshVC7lYn2xOocbuE8dPtUg/viewform?embedded=true" width="100%" height="1700" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
          </TabPanelNoPadding>
        </SwipeableViews>

      </Paper>
    </ThemeProvider>
  );
}

export default App;
